import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { type ConfettiStore, ConfettiVariant } from './types';

const defaultTasksState: ConfettiStore = {
  confetties: [],
  actions: {
    show: () => {},
    remove: () => {},
    showPaid: () => {},
  },
};

const useConfettiStateRaw = create<ConfettiStore>()((set) => ({
  ...defaultTasksState,
  actions: {
    show: (variant = ConfettiVariant.bottom) => {
      set((prev) => ({
        confetties: [...prev.confetties, { key: Math.random().toString(), variant }],
      }));
    },
    remove: () => {
      set((prev) => ({
        confetties: prev.confetties.slice(1),
      }));
    },
    showPaid: () => {
      set(() => ({
        confetties: [
          { key: Math.random().toString(), variant: ConfettiVariant.bottom },
          { key: Math.random().toString(), variant: ConfettiVariant.screen },
          { key: Math.random().toString(), variant: ConfettiVariant.paid },
        ],
      }));
    },
  },
}));

export const useConfettiState = () =>
  useConfettiStateRaw(useShallow((state) => state.confetties));

export const useConfettiActions = () =>
  useConfettiStateRaw(useShallow((state) => state.actions));

export const useConfetti = () =>
  useConfettiStateRaw(useShallow((state) => state.actions.show));

export const useConfettiPaid = () =>
  useConfettiStateRaw(useShallow((state) => state.actions.showPaid));
